export default __webpack_public_path__ + "static/media/ZI Chat logo.da14d933.svg";